export class SkuPrice {
    constructor(
        public date: string,
        public price: number,
        public regularPrice: number,
        public isOffer: boolean,
        public isOutOfStock: boolean,
        public priceChangePercent: number
    ) {}
}
